<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'refund'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">All Refund Request</h1>
						</div>

						<div class="product-infos-wrapper-pc">
							<el-table :data="refundOrderList" style="width: 100%" v-loading="tableLoading"
								empty-text="No Data">
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="product" label="Date"></el-table-column>
								<el-table-column prop="customer" label="Order Id"></el-table-column>
								<el-table-column prop="rating" label="Product"></el-table-column>
								<el-table-column prop="comment" label="Amount"></el-table-column>
								<el-table-column prop="published" label="Status">
									<template v-slot="scope">
										<el-tag type="success">Published</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="comment" label="	Reason"></el-table-column>
								<el-table-column prop="comment" label="Approval"></el-table-column>
								<el-table-column prop="comment" label="Reject"></el-table-column>
							</el-table>
						</div>

						<div class="product-infos-wrapper-mobile">
							<el-table :data="refundOrderList" style="width: 100%" v-loading="tableLoading"
								empty-text="No Data">
								<el-table-column type="expand">
									<template v-slot="scope">
										<div class="expanded-content">
											<p><strong>Date:</strong> {{ scope.row.product }}</p>
											<p><strong>Product:</strong> {{ scope.row.comment }}</p>
											<p><strong>Amount:</strong> {{ scope.row.published }}</p>
											<p><strong>Status:</strong> {{ scope.row.published }}</p>
										</div>
									</template>
								</el-table-column>
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="customer" label="Order Id"></el-table-column>
								<el-table-column prop="rating" label="Approval"></el-table-column>
							</el-table>
						</div>
						<!-- 分页组件 -->
						<div class="page-contrainer d-flex">
							<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next"
								:total="total" :current-page.sync="queryParams.pageNum"
								@current-change="getRefundOrderList"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		refundlist
	} from '../../api/order.js'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				tableLoading: false,
				refundOrderList: [],
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isMobile: false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getRefundOrderList()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			getRefundOrderList() {
				this.tableLoading = true
				refundlist(this.queryParams).then(res => {
					this.tableLoading = false
					if (res.code == 200) {
						this.refundOrderList = res.rows
						this.total = res.total
					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/review.css");
</style>
<style scoped>
	.product-infos-wrapper-mobile {
		display: none;
	}

	.product-infos-wrapper-pc {
		display: block;
	}

	@media (max-width: 768px) {
		.product-infos-wrapper-mobile {
			display: block;
		}

		.product-infos-wrapper-pc {
			display: none;
		}

	}
</style>
